import { DateTime } from 'luxon';

// Zona del negocio: las fechas se le muestran al cliente en hora de Chile, no en la
// del navegador. Es la misma zona que usa el backend (claim.service usa luxon con
// 'America/Santiago' para la ventana de carga de documentos).
const BUSINESS_ZONE = 'America/Santiago';

/**
 * Formatea un instante ISO-8601 como DD-MM-YYYY en hora de Chile.
 *
 * Se usa luxon y no los getters nativos porque `new Date(iso).getDate()` resuelve en la
 * zona del navegador: un caso creado a las 21:00 en Chile viaja como `...T01:00Z` del día
 * siguiente y se pintaba con la fecha corrida un día. Luxon además maneja el cambio de
 * horario de Chile (-3 en verano, -4 en invierno), que un offset fijo no cubriría.
 *
 * Devuelve '' si el valor está vacío o no es una fecha válida, para que el llamador
 * simplemente no muestre nada.
 */
export const formatDate = (iso?: string | null): string => {
  if (!iso) return '';
  const date = DateTime.fromISO(iso, { zone: BUSINESS_ZONE });
  return date.isValid ? date.toFormat('dd-MM-yyyy') : '';
};
